import React from "react";

const UserAvatar = () => {
  return (
    <div>
      <h1 className="route">User Avatar</h1>
    </div>
  );
};

export default UserAvatar;
